/**
 * 配置值读取器.
 *
 * @author yusangeng@outlook.com
 */
import { __spreadArray } from "tslib";
import isUndefined from "lodash/isUndefined";
import isFunction from "lodash/isFunction";
import noop from "lodash/noop";
import split from "./split";
var isArray = Array.isArray;
var keys = Object.keys, defineProperty = Object.defineProperty;
/**
 * 配置值读取器.
 *
 * @class Reader
 * @private
 */
var Reader = /** @class */ (function () {
    /**
     * 构造函数.
     *
     * @param {KonphGlobal} globalConf 全局配置变量.
     * @param {string} url url字符串.
     * @param {KonphOptions} options 配置项读取设置.
     *
     * @memberof Reader
     */
    function Reader(globalConf, url, options) {
        var _this = this;
        this.globalConf_ = globalConf;
        this.urlConf_ = split(url);
        this.options_ = options;
        var cache = (this.cache_ = {});
        var fitContext = (this.fitContext_ = {});
        keys(options).forEach(function (key) {
            var kk = key.toLowerCase().trim();
            cache[kk] = noop;
            defineProperty(fitContext, kk, {
                get: function () { return _this.item(kk); }
            });
        });
    }
    /**
     * 读取配置项.
     *
     * @param {string} key 配置项名称(不区分大小写)，两边的空格会被trim掉.
     * @returns {any} 配置项的值.
     *
     * @memberof Reader
     * @instance
     */
    Reader.prototype.item = function (key) {
        var _this = this;
        var _a;
        var kk = (typeof key === "string" ? key.toLowerCase().trim() : key);
        var cacheValue = (_a = this.cache_[kk]) !== null && _a !== void 0 ? _a : noop;
        if (cacheValue !== noop) {
            // 命中缓存
            return cacheValue;
        }
        // 当前项的配置
        var item = this.options_[kk];
        if (typeof item === "undefined" || item === null) {
            throw new Error("Bad key: ".concat(kk, "."));
        }
        if (["string", "number", "boolean"].includes(typeof item)) {
            return item;
        }
        if (item.__konph_private_item__) {
            // 私有配置
            return item.value;
        }
        var _b = item, def = _b.def, defaultValue = _b.defaultValue, fit = _b.fit, deps = _b.deps;
        // url参数的优先级最高
        var value = this.urlConf_[kk];
        if (isUndefined(value)) {
            // 全局变量优先级次之
            value = this.globalConf_[kk];
        }
        if (isUndefined(value)) {
            // 默认值优先级最低
            value = isUndefined(def) ? defaultValue : def; // defaultValue是def的老写法
        }
        if (isFunction(fit)) {
            // 由于url参数总是字符串, 所以如果必要的话, 这里需要使用一个fit函数转型
            // 如果需要对配置值做一些特殊处理, 也可在fit执行
            // 兼容老版本
            // 老版本不能自动分析依赖, 需要使用deps字段声明依赖
            var depValues = [];
            if (isArray(deps) && deps.length) {
                // 要计算当前配置项的值，首先读取它依赖的配置项
                depValues = deps.map(function (dep) { return _this.item(dep); });
            }
            if (depValues.length) {
                // 老写法
                // 如果填写了deps, 同时fit函数是箭头函数, 则依赖分析不可用
                value = fit.call.apply(fit, __spreadArray([this.fitContext_, value], depValues, false));
            }
            else {
                // 新写法
                // 由于fit函数有通常是箭头函数, bind this无效，所以要使用第二个参数传递fitContext
                value = fit.call(this.fitContext_, value, this.fitContext_);
            }
        }
        this.cache_[kk] = value;
        return value;
    };
    return Reader;
}());
export default Reader;
//# sourceMappingURL=data:application/json;base64,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